import { cn } from '@/lib/cn';
import { ChevronDown } from 'lucide-react';
import type { SelectHTMLAttributes } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: { value: string | number; label: string }[];
  placeholder?: string;
  /** Se true, o placeholder fica selecionável (ex.: “Sem lote”). */
  allowEmpty?: boolean;
}

export function Select({
  label,
  error,
  options,
  placeholder,
  allowEmpty = false,
  className,
  id,
  ...props
}: SelectProps) {
  const selectId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="space-y-1.5">
      {label && (
        <label htmlFor={selectId} className="block text-sm font-medium text-manejai-bark">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          id={selectId}
          className={cn(
            'w-full h-10 cursor-pointer appearance-none rounded-xl border bg-white pl-3 pr-9 text-sm transition-colors',
            'focus:outline-none focus:ring-2 focus:ring-manejai-sage/40 focus:border-manejai-sage',
            error ? 'border-red-400' : 'border-manejai-sand',
            className,
          )}
          {...props}
        >
          {placeholder && (
            <option value="" disabled={!allowEmpty}>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDown
          className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-manejai-bark/45"
          aria-hidden
        />
      </div>
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
}
